import { initializeApp } from '@firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from '@firebase/auth';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  CustomProvider,
  getToken as getAppCheckToken,
  AppCheck,
} from '@firebase/app-check';
import { getEnv, getEnvFlag } from './utils/env';

const firebaseConfig = {
  apiKey: "AIzaSyAKetvtAKTwawC95--NAqdDCvgBlbP1tPI",
  authDomain: "belivah-936c0.firebaseapp.com",
  projectId: "belivah-936c0",
  messagingSenderId: "1029804121793",
  appId: "1:1029804121793:web:cccf10d6904eea933fbe40",
  measurementId: "G-2Y8RD5JY9D"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
// Database client removed. Keep a placeholder export to minimize churn while the UI migrates.
export const db: any = {};

const apiBaseOverride = getEnv('REACT_APP_API_BASE_URL');
export const apiBaseUrl = (apiBaseOverride || '').replace(/\/$/, '');
const isLocalhost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

let appCheckInstance: AppCheck | null = null;

function ensureAppCheck() {
  if (appCheckInstance || typeof window === 'undefined') {
    return appCheckInstance;
  }
  const siteKey = getEnv('REACT_APP_RECAPTCHA_SITE_KEY') || '';
  const debugToken = (getEnv('REACT_APP_APPCHECK_DEBUG_TOKEN') || '').trim();

  // App Check can block Auth calls when enforcement is enabled.
  // For local dev, only enable debug mode if a stable token is explicitly provided.
  if (!siteKey && isLocalhost && !debugToken) {
    console.warn(
      'App Check is disabled on localhost. If Firebase App Check enforcement is enabled, set REACT_APP_APPCHECK_DEBUG_TOKEN to a registered debug token.',
    );
    return null;
  }

  if (!siteKey) {
    if (!isLocalhost) {
      // App Check is optional (the API does not enforce it), so stay quiet in production.
      return null;
    }
    if (debugToken) {
      (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
    }
  }
  try {
    const provider = siteKey
      ? new ReCaptchaV3Provider(siteKey)
      : new CustomProvider({
          getToken: async () => ({
            token: 'local-app-check-debug',
            expireTimeMillis: Date.now() + 30 * 60 * 1000,
          }),
        });
    appCheckInstance = initializeAppCheck(app, {
      provider,
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    console.error('Failed to initialize App Check', err);
  }
  return appCheckInstance;
}

if (typeof window !== 'undefined') {
  ensureAppCheck();
}

// Local-only helper to simplify manual API verification during the VPS migration.
// This is not used by the app runtime; it only helps developers fetch tokens from DevTools.
if (typeof window !== 'undefined' && isLocalhost) {
  (window as any).__belivahDebug = {
    auth,
    fetchIdToken: async () => {
      const user = auth.currentUser;
      if (!user) return null;
      return user.getIdToken();
    },
    fetchAppCheckToken,
  };
}

export async function fetchAppCheckToken(forceRefresh = false): Promise<string | null> {
  const instance = ensureAppCheck();
  if (!instance) {
    return null;
  }
  try {
    const result = await getAppCheckToken(instance, forceRefresh);
    return result.token;
  } catch (err) {
    console.warn('Failed to resolve App Check token', err);
    return null;
  }
}

// Optional: connect to local emulators when developing on localhost
// Enable by setting REACT_APP_USE_EMULATORS=true in client/.env
if (typeof window !== 'undefined' && isLocalhost) {
  const useEmulators = getEnvFlag('REACT_APP_USE_EMULATORS');
  if (useEmulators) {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099');
    } catch {}
  }
}
export default app;



